import React from "react";
import AtencionCliente from "../formulario-atencion-cliente/atencion-cliente";
import ConsultaReclamo from "../formulario-consulta-solicitud/consulta-reclamo";
import PaginaCarga from "../pagina-carga/carga";
import PaginaEstado from "../pagina-estado/estado";
import FooterSite from "../generic/footer/footer";
import DevolucionesCliente from "../formulario-devoluciones/formulario-devoluciones";


import "./componente-principal.css";

const { obtenerMotivo, enviarFormulario, obtenerReclamo, obtenerTextos, enviarFormularioDevolucion } = require("../generic/utils/utils");

export default class FormPrincial extends React.Component {

    constructor(props) {
        super();
        this.state = {
            inStep: props.inStep,
            inStepMantatorio: props.inStep,
            titulo: props.titulo,
            empresa: props.empresa,
            mensaje: props.mensaje,
            texto: props.texto,
            textos: [],
            status: props.status,
            linea: props.linea,
            solicitud: null,
            onlyCarga: false,
            retorno: null,
            isLoadable: props.isLoadable,
            data: [],
            dataForm: null,
            dataSubMotivo: null,
            dataTpReclamo: null
        }
    }

    result = async (e) => {
        this.setState({ inStep: e.inStep, titulo: e.titulo, texto: e.texto, status: e.status, retorno: 0 });
    }

    precarga(retorno) {
        this.setState({ inStep: 0, onlyCarga: true, retorno: retorno });
    }

    setObtenerMotivo = async (e) => {
        let data = [];
        let textos = [];
        textos = await this.setTextos();
        if (e) {
            this.setState({ inStep: 0, retorno: 0 });
        } else {
            if (this.state.inStep === 1) {
                data = await obtenerMotivo(99);
            } else {
                data.inStep = this.state.inStep;
                data.data = [];
                data.texto = "";
                data.mensaje = "";
                data.status = "success";
            }
            this.setState({ data: data.data, inStep: data.inStep, texto: data.texto, mensaje: data.mensaje, status: data.status, retorno: 0, textos: textos, isLoadable: false });
        }

    }

    setTextos = async (even) => {
        let textosObtenidos = [];
        textosObtenidos = await obtenerTextos();
        return textosObtenidos.data;
    }

    finish = async (form, dataSubMotivo, dataTpReclamo) => {
        form.linea = this.state.linea
        this.precarga(0);
        let data = await enviarFormulario(form);
        this.setState({
            data: data.data, inStep: data.inStep, texto: data.texto,
            mensaje: data.mensaje, status: data.status, solicitud: data.data.numero_reclamo,
            retorno: 0, dataForm: data.status !== "success" ? form : null,
            dataSubMotivo: dataSubMotivo,
            dataTpReclamo: dataTpReclamo
        });
    }

    getNumeroReclamo = async (form) => {
        this.precarga(1);
        let data = await obtenerReclamo(form.reclamo.solicitud.numero, form.reclamo.solicitud.tipo_consulta, form.reclamo.solicitante.rut, form.reclamo.solicitante.dv, form.reclamo.solicitud.empresa);
        this.setState({ data: data.data, inStep: data.inStep, texto: data.texto, mensaje: data.mensaje, status: data.status, retorno: 1, dataForm: form });
    }

    finishDevolucion = async (formulario) => {
        formulario.reclamo.detalleReclamo.linea = this.state.linea;
        this.precarga(0);
        let data = await enviarFormularioDevolucion(formulario.reclamo);
        this.setState({
            data: data.data, inStep: data.inStep, texto: data.texto,
            mensaje: data.mensaje, status: data.status, solicitud: data.data.numero_reclamo,
            retorno: 0, dataForm: data.status !== "success" ? formulario : null
        });
    }

    render() {

        let step = this.state.inStep;
        let isLoadable = this.state.isLoadable;
        let contenedor;

        if (isLoadable) {
            step = 0;
        } else {

        }


        switch (step) {
            case 0:
                contenedor = <PaginaCarga onChange={this.setObtenerMotivo} onlyCarga={this.state.onlyCarga} />
                break;
            case 1:
                contenedor = <AtencionCliente titulo={this.state.titulo} empresa={this.state.empresa} data={this.state.data} onChange={this.result}
                    onComplete={this.finish} precargaForm={this.state.dataForm} dataSubMotivo={this.state.dataSubMotivo} dataTpReclamo={this.state.dataTpReclamo}
                    textos={this.state.textos} />;
                break;
            case 2:
                contenedor = <ConsultaReclamo titulo={this.state.titulo} empresa={this.state.empresa} data={this.state.data} linea={this.state.linea}
                    onChange={this.result} onComplete={this.getNumeroReclamo} precargaForm={this.state.dataForm} textos={this.state.textos} />
                break;
            case 3:
                contenedor = <>
                    <PaginaEstado mensaje={this.state.mensaje} texto={this.state.texto} status={this.state.status} solicitud={this.state.solicitud} />
                </>
                break;
            case 4:
                contenedor = <DevolucionesCliente titulo={this.state.titulo} empresa={this.state.empresa} data={this.state.data} textos={this.state.textos}
                    onChange={this.result} onComplete={this.finishDevolucion} precargaForm={this.state.dataForm} dataSubMotivo={this.state.dataSubMotivo}
                    dataTpReclamo={this.state.dataTpReclamo}/>;
                break;
            default:
                contenedor = <>
                    <PaginaEstado mensaje={this.state.mensaje} texto={this.state.texto} status={this.state.status} solicitud={this.state.solicitud} />
                </>
                break;
        }

        return (
            <>
                {contenedor}
                <br></br>
                <FooterSite />
            </>
        );
    }
}